import { render, staticRenderFns } from "./brandCustomers.vue?vue&type=template&id=33fa1e22&scoped=true&"
import script from "./brandCustomers.vue?vue&type=script&lang=js&"
export * from "./brandCustomers.vue?vue&type=script&lang=js&"
import style0 from "./brandCustomers.vue?vue&type=style&index=0&id=33fa1e22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fa1e22",
  null
  
)

export default component.exports